import { FETCH_SENSORS, FETCH_SENSOR,FETCH_COMPONENTS , FETCH_SUBSYSTEM, FETCH_LISTSENSORS } from '../types/sensor';

const initialState = {
  sensors: [],
  sensor: {},
  components :[],
  subsystems :[],
  sensorscomp :[],
  
};


/* store generation sensors components  sensor  subsystems  sensorscomp  with type FETCH_SENSORS, FETCH_SENSOR,FETCH_COMPONENTS , FETCH_SUBSYSTEM, FETCH_LISTSENSORS 
  sensors: [],
  sensor: {},
  components :[],
  subsystems :[],
  sensorscomp :[],
    case FETCH_SENSORS:
      return { ...state, sensors: [action.payload] };

    case FETCH_SENSOR:
      return { ...state, sensor: [action.payload] };


      case FETCH_COMPONENTS:
        return { ...state, components: [action.payload] };

        case FETCH_SUBSYSTEM:
          return { ...state, subsystems: [action.payload] };

          case FETCH_LISTSENSORS:


*/


export default (state = initialState, action) => {
  switch (action.type) {

    case FETCH_SENSORS:
      return { ...state, sensors: [action.payload] };

    case FETCH_SENSOR:
      return { ...state, sensor: [action.payload] };


      case FETCH_COMPONENTS:
        return { ...state, components: [action.payload] };

        case FETCH_SUBSYSTEM:
          return { ...state, subsystems: [action.payload] };

          case FETCH_LISTSENSORS:
            return { ...state, sensorscomp: [action.payload] };

    default:
      return state;
  }
};